function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) { return; } var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import React, { useState, useEffect, useMemo } from 'react';
import { Icon } from 'mkui-fd';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { PAGE_SIZE } from '../constant';
import { getNavImgs } from '../utils';

var NumberTop = function NumberTop(_ref) {
  var selectKey = _ref.selectKey,
      imgs = _ref.imgs,
      prefixCls = _ref.prefixCls;
  return React.createElement("div", {
    className: "".concat(prefixCls, "-number")
  }, "".concat(selectKey + 1, " / ").concat(imgs.length));
};

var Navigation = function Navigation(props) {
  var prefixCls = props.prefixCls,
      onSwitch = props.onSwitch,
      imgs = props.imgs,
      selectKey = props.selectKey;

  var _useState = useState(getNavImgs(imgs, 0)),
      _useState2 = _slicedToArray(_useState, 2),
      navImgs = _useState2[0],
      setNavImgs = _useState2[1];

  var _useState3 = useState(0),
      _useState4 = _slicedToArray(_useState3, 2),
      navStartIndex = _useState4[0],
      setNavStartIndex = _useState4[1];

  var _useState5 = useState(0),
      _useState6 = _slicedToArray(_useState5, 2),
      activeIndex = _useState6[0],
      setActiveIndex = _useState6[1];

  var setNewNavigation = function setNewNavigation(_ref2) {
    var nextImgs = _ref2.imgs,
        newStartIndex = _ref2.newStartIndex,
        selectKey = _ref2.selectKey;
    setNavStartIndex(newStartIndex);
    setNavImgs(getNavImgs(nextImgs, newStartIndex));
    setActiveIndex(selectKey - newStartIndex);
  };

  useEffect(function () {
    /** nav 视图内切换 */
    if (selectKey >= navStartIndex && selectKey < navStartIndex + PAGE_SIZE) {
      if (selectKey - navStartIndex !== activeIndex) {
        setActiveIndex(selectKey - navStartIndex);
      }
    }
    /** nav 右侧切换 */


    if (selectKey > navStartIndex + PAGE_SIZE - 1) {
      var step = selectKey - (navStartIndex + PAGE_SIZE - 1);
      var newStartIndex = 0;

      if (step === 1) {
        newStartIndex = navStartIndex + 1;
      } else {
        var offset = selectKey - 2;
        newStartIndex = offset < imgs.length - PAGE_SIZE ? offset : imgs.length - PAGE_SIZE;
      }

      setNewNavigation({
        imgs: imgs,
        newStartIndex: newStartIndex,
        selectKey: selectKey
      });
    }
    /** nav 左侧切换 */


    if (selectKey < navStartIndex) {
      var _step = navStartIndex - selectKey;

      var _newStartIndex = 0;

      if (_step === 1) {
        _newStartIndex = navStartIndex - 1;
      } else {
        var _offset = selectKey - 2;

        _newStartIndex = _offset > 0 ? _offset : 0;
      }

      setNewNavigation({
        imgs: imgs,
        newStartIndex: _newStartIndex,
        selectKey: selectKey
      });
    }
  }, [imgs, selectKey, activeIndex, navStartIndex]);
  var navContent = useMemo(function () {
    var renderImg = function renderImg(img, index) {
      var url = img.url,
          type = img.type,
          thumbnailUrl = img.thumbnailUrl;

      switch (type) {
        case 'img':
          return React.createElement("img", {
            key: img.code,
            src: thumbnailUrl || url,
            onClick: function onClick() {
              onSwitch('target', index + navStartIndex);
            },
            alt: "fail"
          });

        case 'pdf':
          return React.createElement(Icon, {
            className: "nav-nail-font",
            type: "pdf-file",
            theme: "outlined",
            onClick: function onClick() {
              onSwitch('target', index + navStartIndex);
            }
          });

        case 'none':
          return React.createElement("span", {
            className: "nav-nail-font",
            onClick: function onClick() {
              onSwitch('target', index + navStartIndex);
            }
          });

        default:
          break;
      }
    };

    return navImgs.map(function (img, index) {
      return React.createElement("div", {
        className: classNames('nav-img', {
          active: activeIndex === index
        }),
        key: img.code
      }, renderImg(img, index));
    });
  }, [navImgs, activeIndex]);
  return React.createElement("div", {
    className: prefixCls
  }, React.createElement(NumberTop, props), React.createElement("div", {
    className: "".concat(prefixCls, "-body")
  }, React.createElement("div", {
    className: "".concat(prefixCls, "-body-prev")
  }, React.createElement("div", {
    className: "".concat(prefixCls, "-body-prev-arrows"),
    onClick: function onClick() {
      onSwitch('prev');
    }
  }, React.createElement(Icon, {
    className: "arrows-icon",
    type: "left"
  }))), React.createElement("div", {
    className: "".concat(prefixCls, "-body-content")
  }, navContent), React.createElement("div", {
    className: "".concat(prefixCls, "-body-next")
  }, React.createElement("div", {
    className: "".concat(prefixCls, "-body-prev-arrows"),
    onClick: function onClick() {
      onSwitch('next');
    }
  }, React.createElement(Icon, {
    className: "arrows-icon",
    type: "right"
  })))));
};

Navigation.propTypes = {
  imgs: PropTypes.array,
  selectKey: PropTypes.number,
  onSwitch: PropTypes.func,
  prefixCls: PropTypes.string
};
Navigation.defaultProps = {
  imgs: [],
  selectKey: 0,
  onSwitch: function onSwitch() {},
  prefixCls: 'mkui-image-viewer-nav'
};
export default Navigation;
//# sourceMappingURL=Navigation.js.map
